export const DEFAULT_OPTIONS = {
  ACCOUNT_TYPE: "SIN_RELACION",
};

export const accountTypeOptions = [
  { label: "BANCOS", value: "BANCOS" },
  { label: "CLIENTES", value: "CLIENTES" },
  { label: "IVA POR TRASLADAR", value: "IVA_POR_TRASLADAR" },
  { label: "IVA TRASLADADO COBRADO", value: "IVA_TRASLADADO_COBRADO" },
  { label: "VENTA MENUDEO CONTADO", value: "VENTA_MENUDEO_CONTADO" },
  { label: "VENTA MENUDEO CREDITO", value: "VENTA_MENUDEO_CREDITO" },
  { label: "DESCUENTOS SOBRE VENTAS", value: "DESCUENTOS_SOBRE_VENTAS" },
  { label: "SIN RELACION", value: "SIN_RELACION" },
  { label: "CUENTA CONTABLE POLIZA EGRESOS", value: "CUENTA_CONTABLE_POLIZA_EGRESOS" },
  { label: "CUENTA CONTABLE POLIZA DIARIO", value: "CUENTA_CONTABLE_POLIZA_DIARIO" },
  { label: "IVA ACREDITAR POLIZA DIARIO", value: "IVA_ACREDITAR_POLIZA_DIARIO" },
  { label: "IVA ACREDITABLE POLIZA DIARIO", value: "IVA_ACREDITABLE_POLIZA_DIARIO" },
  { label: "VOLUMEN DE VENTAS", value: "VOLUMEN_DE_VENTAS" },
  { label: "CONTRACUENTA VOLUMEN DE VENTAS", value: "CONTRACUENTA_VOLUMEN_DE_VENTAS" },
  { label: "VENTA MENUDEO CONTADO VENTA PLANTA", value: "VENTA_MENUDEO_CONTADO_VENTA_PLANTA" },
];

// Tipos que la Póliza resuelve con un solo registro (accounts.find en
// CORE/BILLING/src/servs/policy_details.ts de crm_backend): no pueden
// repetirse para la misma compañía y planta. Si se reactiva addCreditSales,
// agregar CLIENTES y VENTA_MENUDEO_CREDITO.
export const UNIQUE_RELATION_TYPES = [
  "VENTA_MENUDEO_CONTADO",
  "IVA_POR_TRASLADAR",
  "IVA_TRASLADADO_COBRADO",
  "VOLUMEN_DE_VENTAS",
  "CONTRACUENTA_VOLUMEN_DE_VENTAS",
  "VENTA_MENUDEO_CONTADO_VENTA_PLANTA",
];
